import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  notFoundWrapper: {
    '&&': {
      padding: `${SPACES.xxl} 0 ${SPACES.xxxl}`,

      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: SPACES.s,

      borderRadius: '15px',
      border: `1px solid ${theme.palette.custom.grey}`,

      [theme.breakpoints.down('tablet')]: {
        marginLeft: 'auto',
        marginRight: 'auto',

        width: '100%',
        maxHeight: 146,
      },

      [theme.breakpoints.up('tablet')]: {
        justifyContent: 'center',
        width: 178,
        height: 178,
      },
    },
  },
  notFoundTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.388,
      color: theme.palette.custom.darkBlue2,
    },
  },
  notFoundDescription: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.333,
      color: theme.palette.custom.darkBlue2,
    },
  },
}))
